module.exports = __webpack_public_path__ + "img/2.d59922a9.gif";